module.exports = __webpack_public_path__ + "40170eaefaec7dd22e1d1cf3adb79d4c.png";